import React from 'react'
import {ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader} from 'reactstrap'
import DOMPurify from 'dompurify'

let UserSelectionModal = ({modal, toggle, submit, className, title, text, choices}) =>
    <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
            <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}/>
            <br/>
            <ListGroup>
                {(choices && choices.length ? choices.map((choice, idx) =>
                    <ListGroupItem key={`choice-${idx}`}
                                   tag="button"
                                   onClick={() => submit(choice)}
                                   action>
                        &emsp;
                        {choice.name}
                    </ListGroupItem>
                ) : null)}
            </ListGroup>
        </ModalBody>
    </Modal>

export default UserSelectionModal



// WEBPACK FOOTER //
// ./src/components/ui/UserSelectionModal.js